const STAGES = ["Footwear", "Apparel", "Intuitive Fit"];

const Vision = () => (
  <section id="vision" data-testid="vision-section" className="section-pad border-t border-[var(--line)]">
    <div className="container-x grid gap-14 lg:grid-cols-2 lg:gap-20">
      <div>
        <p className="eyebrow mb-6">The Vision</p>
        <h2 className="font-display text-4xl leading-[1.1] tracking-tight sm:text-5xl">
          Shoes are just the starting point.
        </h2>
        <p className="font-display mt-6 text-xl italic text-[var(--rust)] md:text-2xl">
          From Intuitive Shoes to Intuitive Fit.
        </p>
      </div>

      <div className="flex flex-col justify-center">
        <p className="max-w-md text-base leading-relaxed text-[var(--ink-soft)]">
          The same crowdsourced approach to real-world fit has the potential to
          extend beyond footwear. The longer-term vision is Intuitive Fit — a
          customizable fit-intelligence layer that could support apparel and
          different ecommerce environments.
        </p>

        <ol data-testid="vision-progression" className="mt-10 flex flex-wrap items-center gap-y-3">
          {STAGES.map((stage, i) => (
            <li key={stage} className="flex items-center">
              <span
                className={`font-display rounded-md border px-4 py-2 text-base ${
                  stage === "Intuitive Fit"
                    ? "border-[var(--rust)] text-[var(--rust)]"
                    : "border-[var(--line)]"
                }`}
              >
                {stage}
              </span>
              {i < STAGES.length - 1 && (
                <span aria-hidden="true" className="mx-3 text-[var(--line)]">
                  →
                </span>
              )}
            </li>
          ))}
        </ol>

        <p className="mt-8 border-l-2 border-[var(--rust)] pl-4 text-sm italic leading-relaxed text-[var(--ink-soft)]">
          Intuitive Fit is a future vision — not a product available today.
        </p>
      </div>
    </div>
  </section>
);

export default Vision;
